var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTriangleDown = function SvgTriangleDown(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    color: "currentColor",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M18.593 8.195a1 1 0 0 1 .212 1.398 53.178 53.178 0 0 1-2.457 3.063c-.662.762-1.396 1.55-2.081 2.156-.342.302-.695.58-1.04.787-.316.19-.751.401-1.227.401s-.912-.21-1.228-.401a7.4 7.4 0 0 1-1.039-.787c-.685-.606-1.42-1.394-2.081-2.156a53 53 0 0 1-2.457-3.063 1 1 0 0 1 .212-1.398A1 1 0 0 1 6 8h12a1 1 0 0 1 .593.195"
  })));
};
export default SvgTriangleDown;